module.exports = __webpack_public_path__ + "media/new_message_voice.927dc004.mp3";